class CompareSearchIndex {
  static isReady() {
    return !!CompareSearchIndex._items;
  }

  static async get() {
    if (CompareSearchIndex._items) return CompareSearchIndex._items;
    if (CompareSearchIndex._promise) return CompareSearchIndex._promise;

    const cached = BtStorageUtil.get(CompareSearchIndex.key, true, true);
    if (cached) {
      CompareSearchIndex._items = cached;
      return cached;
    }

    CompareSearchIndex._promise = CompareSearchIndex.build().then((items) => {
      CompareSearchIndex._items = items;
      CompareSearchIndex._promise = null;
      return items;
    });

    return CompareSearchIndex._promise;
  }

  static async build() {
    const first = await CompareSearchIndex.fetchPage(1);
    let items = first.items;

    if (first.totalPages > 1) {
      const pagePromises = [];
      for (let page = 2; page <= first.totalPages; page++) {
        pagePromises.push(CompareSearchIndex.fetchPage(page));
      }
      const rest = await Promise.all(pagePromises);
      rest.forEach((result) => {
        items = items.concat(result.items);
      });
    }

    BtStorageUtil.set(CompareSearchIndex.key, items, true);
    return items;
  }

  static async fetchPage(page) {
    try {
      const response = await fetch(`/?section_id=compare-search-index&page=${page}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const container = doc.querySelector('.compare-search-index');
      const script = doc.querySelector('[data-compare-search-index-json]');

      let items = [];
      if (script) {
        try {
          items = JSON.parse(script.textContent);
        } catch (e) {
          items = [];
        }
      }

      const totalPages = container ? parseInt(container.dataset.totalPages, 10) || 1 : 1;
      return { items, totalPages };
    } catch (e) {
      return { items: [], totalPages: 1 };
    }
  }

  static async search(query, category) {
    const items = await CompareSearchIndex.get();
    const q = query.trim().toLowerCase();
    if (!q) return [];

    return items
      .filter((item) => {
        if (category && item.category !== category) return false;
        return (item.title && item.title.toLowerCase().includes(q)) ||
               (item.model && item.model.toLowerCase().includes(q));
      })
      .slice(0, 10);
  }
}

CompareSearchIndex.key = 'compare-search-index';

window.CompareSearchIndex = CompareSearchIndex;
